import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import isNil from 'lodash.isnil';
import {
    ENTER_END_TIME_MESSAGE,
    SECONDS_REG_EXP,
} from '../../../../../../../constants/reading/TroConstants';
import { convertFromSecondsToMs } from '../../../../../../../utils/shared/commonUtils';
import Button from '../../../../../../../components/button/Button';
import './EndTimeModal.scss';

const EndTimeModal = ({ isShown, wordPosition, setEndWordData, audioDuration }) => {
    const [endTime, setEndTime] = useState('');
    const [isEndTimeShown, setIsEndTimeShown] = useState(isShown);

    useEffect(() => {
        if (isEndTimeShown) {
            setEndWordData(wordPosition, null);
            setIsEndTimeShown(false);
        }
    }, [isEndTimeShown]);

    const onHandleTimeChange = e => {
        const time = e.target.value;
        if ((time === '' || SECONDS_REG_EXP.test(time)) && Number(time) <= audioDuration) {
            setEndTime(time);
        }
    };

    const saveEndWord = () => {
        setEndWordData(wordPosition, convertFromSecondsToMs(endTime));
    };

    return (
        <div className="end-time-wrapper">
            <header className="end-time-header">{ENTER_END_TIME_MESSAGE}</header>
            <div className="end-time-content">
                <span className="end-time-title">Enter time in seconds:</span>
                <div className="end-time">
                    <input
                        placeholder="00"
                        type="text"
                        value={endTime}
                        onChange={onHandleTimeChange}
                    />
                    <Button
                        dataTestId="save-time-btn"
                        isDisabled={isNil(endTime) || endTime > audioDuration || endTime < 1}
                        className="btn rescoring-primary"
                        text="Save Timestamp"
                        onClick={saveEndWord}
                    />
                </div>
            </div>
        </div>
    );
};

EndTimeModal.defaultProps = {
    isShown: false,
    wordPosition: null,
    audioDuration: null,
    setEndWordData: () => {},
};

EndTimeModal.propTypes = {
    isShown: PropTypes.bool,
    wordPosition: PropTypes.number,
    audioDuration: PropTypes.number,
    setEndWordData: PropTypes.func,
};

export default EndTimeModal;
